import PlatformTestScenarios from './PlatformTestScenarios'

/* eslint-disable camelcase, no-await-in-loop */
export default class PPLIVETestScenarios extends PlatformTestScenarios {
  async multiBets_bet1_bet2_bet3_bet4_settleWin() {
    // PP-LIVE-001 不會發生同一局多筆 bet 的情境，需改用 PP-LIVE-082
    this.requests.actions.constantTxnData.gameCode = 'PP-LIVE-082'
    this.requests.actions.gameName = 'Blackjack X 1'

    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()

        const betDescs = ['Main S4', 'Spl S4', 'Dbl S4, H0', 'Dbl S4, H1']
        const BET_LENGTH = betDescs.length

        const betIndexes = []
        for (let betIndex = 0; betIndex < BET_LENGTH; betIndex += 1) {
          await this.requests.bet({
            betIndexes: [betIndex],
            data: {
              betDesc: betDescs[betIndex],
            },
          })
          betIndexes.push(betIndex)
        }

        await this.requests.settleWin({ betIndexes })
        await this.requests.getBalance({ action: 'settle' })
      },
    )
  }
}
